import * as React from 'react';
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';//取得のみ
import { nftJsonState } from "../states/nftJsonState";

import {
    Box,
    Center,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Text,
} from '@chakra-ui/react';

type Props = {

}

//NFTInfoText コンポーネントの定義
export const NFTInfoDescription: React.FC<Props> = (props) => {
  const nftInfo = useRecoilValue(nftJsonState);
  const nftinfoStyle: React.CSSProperties = {
    marginBottom: '60px',
    position: 'relative',
  };
  const NFTInfo = styled.div`
    font-family: 'Noto Sans JP';
    font-style: normal;
    line-height: 35px;
    align-items: center;
    color: #FFFBFB;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0 auto;
    padding: 0;
    position: relative;
    width: 264px;
    &::before {
      width: 2px;
      height: 100%;
      background: #FFFBFB;
      border: 2px solid #FFFBFB;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      position: absolute;
      content: "";
      display: inline-block;
      left: -13px;
      top: 0;
    }
  `;

  return (
      <>
        <div id='NFTinfo' style={nftinfoStyle}>
            <NFTInfo>
                <Text
                    fontWeight={400}
                    fontSize={'16px'}
                    fontFamily={'sans-serif'}
                    textAlign={'start'}
                >
                    {nftInfo.description}
                </Text>
            </NFTInfo>
        </div>
      </>
  );
};